<template>
	<div class="moreOrigin">
		<back-to :url="packageTour" :query="type"></back-to>
		<section class="moreOrigin_content">
			<!-- 搜索框 -->
			<span class="addressPopups">
				<van-search v-model="cityNameSearch" placeholder="景点、关键词、目的地" background="#f4f4f4" shape="round"
					@search="citySearch" />
			</span>
			<van-index-bar class="addressPopupsAd" :sticky="true" :sticky-offset-top="100" :index-list="indexList"
				ref="anchor">
				<section v-for="(item, index) in list">
					<van-index-anchor :index="item.First" />
					<van-cell v-for="(val, key) in item.projectAndScore" :key="index" :title="val.Name"
						@click="$router.push({path: '/packageSearch',query:{cityData:val,type:type}})" />
				</section>
			</van-index-bar>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'moreOrigin',
		components: {
			BackTo
		},
		data() {
			return {
				packageTour: '/packageTour',
				cityNameSearch: '',
				list: [],
				indexList: [],
				type: 1
			}
		},
		created() {
			this.type = this.$route.query.type
		},
		mounted() {
			this.getPath()
		},
		methods: {
			citySearch(e) {
				window.scrollTo(0, 0)
				this.cityNameSearch = e
				this.getPath()
				// this.$refs.anchor.scrollTo("S");
			},
			getPath() {
				var data = {
					State: this.type == 1 ? 0 : 1, // 0国内 1国外
					Count: 0 // 多少条
				}
				this.$get(
					this.$apiWebsiteSweet + '/api/Applets_GNTeam_StartList?Number=0&Name=' + this.cityNameSearch, data
				).then(res => {
					this.list = this.groupByName(res)
				})
			},
			groupByName(groupData) {
				var indexList = []
				let result = groupData.reduce((prevValue, currentValue) => {
					let index = -1;
					prevValue.some((item, i) => {
						if (item.First == currentValue.First) {
							index = i;
							return true;
						}
					})
					if (index > -1) {
						prevValue[index].projectAndScore.push({
							Name: currentValue.Name,
							Id: currentValue.Id
						})
					} else {
						prevValue.push({
							First: currentValue.First,
							projectAndScore: [{
								Name: currentValue.Name,
								Id: currentValue.Id
							}]
						})
						indexList.push(currentValue.First)
					}
					return prevValue;
				}, []);
				this.indexList = indexList
				return result;
			}

		}
	}
</script>

<style>
	.moreOrigin_content {
		width: 100%;
		margin-top: @nav-bar-height;
	}

	.addressPopups {
		position: fixed;
		top: @nav-bar-height;
		width: 100%;
		left: 0;
		z-index: 3;
	}

	.moreOrigin_content .van-search__content {
		background-color: #ffffff;
	}

	.addressPopupsAd {
		padding-top: 120px;
	}
</style>
